import { render, staticRenderFns } from "./ListLinkItem.vue?vue&type=template&id=54e18370&scoped=true&"
import script from "./ListLinkItem.vue?vue&type=script&lang=ts&"
export * from "./ListLinkItem.vue?vue&type=script&lang=ts&"
import style0 from "./ListLinkItem.vue?vue&type=style&index=0&id=54e18370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e18370",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemIcon } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VIcon,VListItem,VListItemContent,VListItemIcon,VListItemTitle})
